import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const StyledGlobalHeader = styled.div`
  align-items: center;
  background-color: ${({ isLightBackground, theme }) =>
    isLightBackground ? theme.color.gray[50].value : theme.color.globalHeader.background.value};
  color: ${({ theme }) => theme.color.globalHeader.color.value};
  display: flex;
  /* stylelint-disable */
  padding: ${({ theme }) => theme.size.spacing.medium.value} 0;
  padding-right: 6px;
  /* stylelint-enable */
  ${({ isCollapsed }) =>
    isCollapsed &&
    css`
      flex-direction: column;
      padding: ${({ theme }) => theme.size.spacing.medium.value} 0;
    `}
  ${({ isTopMenubar }) =>
    isTopMenubar &&
    css`
      padding-top: 2px;
      padding-bottom: 2px;
    `}
`;

const GlobalHeader = ({ children = null, isCollapsed = false, isLightBackground, isTopMenubar = false, ...other }) => {
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { isCollapsed: isCollapsed });
    }
    return child;
  });

  if (process.env.NODE_ENV === 'development') {
    console.warn(
      'Radial has deprecated the GlobalHeader component. GlobalHeader will have limited support through v7, and it will be removed in v8.  Please do not use this component, as Unify is the only global header necessary in the CDK Application space.'
    );
  }
  return (
    <StyledGlobalHeader
      isCollapsed={isCollapsed}
      isLightBackground={isLightBackground}
      isTopMenubar={isTopMenubar}
      {...other}
    >
      {childrenWithProps}
    </StyledGlobalHeader>
  );
};

GlobalHeader.propTypes = {
  /** Displays any kind of content included between opening and closing tags as a side content */
  children: PropTypes.node,
  /** If true, navigation is collapsed */
  isCollapsed: PropTypes.bool,
  /** If true, the Global Header is styled with light background css styles. */
  isLightBackground: PropTypes.bool,
  /** If true, navigation height is reduced for placement on top of PageHeader */
  isTopMenubar: PropTypes.bool,
};

export { GlobalHeader };
